// src/ScrollToTop.jsx
import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    // Fastest method - no animation
    window.scrollTo(0, 0);
    // Alternative: document.body.scrollTop = 0;
  }, [pathname]);

  return null;
};

export default ScrollToTop;
